// @ts-check

export const Product = {
  Analytics: 'Dashboard',
  Admin: 'Admin Hierarchy',
  SSWebApp: 'SSWebApp',
  MediaPlanner: 'Media Planner',
  InstantIO: 'Instant IO',
  Orders: 'Orders',
  HelpCenter: 'Help Center',
  Portal: 'Portal',
  Placements: 'Placements',
  ManagementReporting: 'Management Reporting',
  CreativeGallery: 'Creative Gallery',
  AdvancedPerformance: 'Advanced Performance',
};

export const PRODUCTS = [
  Product.Analytics,
  Product.MediaPlanner,
  Product.InstantIO,
  Product.Orders,
  Product.SSWebApp,
  Product.HelpCenter,
  Product.CreativeGallery,
  Product.AdvancedPerformance,
];

/**
 * Returns the product name in a normalized format.
 * @param {string} product
 * @returns {string}
 * @example
 * const normalized = normalizeProductName('Placements.io OMS');
 * console.log(normalized);
 * // => 'placements-io-oms'
 */
export const normalizeProductName = (product) => {
  return product.split(/[\s.]+/).join('-');
};
